import React, {useEffect, useState} from 'react';
import {
    Grid,
    Card,
    CardActionArea,
    CardContent,
    Typography,
    Button,
    TextField,
    CardMedia,
    InputAdornment, Box, Breadcrumbs, Container, Divider
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import SearchIcon from "@material-ui/icons/Search";
import '../assets/styles/SmartMarketing.css';
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Breadcrumb from "./BreadcrumbsComponent";
import {useMarketingMaterials} from "./MarketingContext";
import api, {consoleDevLog} from "../apiConfig";
import * as assert from "assert";
import ComingSoon from "./ComingSoon";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing(2),
    },
    card: {
        height: '100%',
    },
    search: {
        marginBottom: theme.spacing(2),
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between', // This will push items apart
    },

    actionArea: {
        flexGrow: 1, // This will let the action area take the available space
    },
    headerTitleLeft: {
        textAlign: "left",
        marginBottom: "10px",
        paddingTop: "50px",
        fontWeight: "bold",
    }
}));

const categories = [
    { name: 'Digital Ads', img: '../src/assets/images/digital-ad.jpeg' },
    { name: 'Presentation', img: '../src/assets/images/home-presentation.png' },
    { name: "Market Updates", img: '../src/assets/images/market-updates.jpeg' },
    { name: "E-mail", img: '../src/assets/images/home-email.png' },
    { name: "One-Pager", img: '../src/assets/images/one-pager.png' },
];

var recentDesigns = [
    { title: 'Design 1', type: 'One-Pager', img: '../src/assets/images/one-pager.png', clientId: '651cbd2188711d875731390a' },
    { title: 'Design 2', type: 'E-mail', img: '../src/assets/images/home-email.png', clientId: '651cbd2188711d875731390a' },
];
const SmartMarketing = (comingSoon=true) => {
    const classes = useStyles();
    const history = useHistory();
    const [searchTerm, setSearchTerm] = useState('');
    const { marketingMaterials, removeMarketingMaterial } = useMarketingMaterials();
    consoleDevLog("Marketing Materials in SmartMarketing:", marketingMaterials);
    const [recentDesigns, setRecentDesigns] = useState([]);

    const handleClick = (category) => {
        history.push(`/designs/${category}`);
    };

    const handleRemoveEmail = (indexToRemove) => {
        consoleDevLog(marketingMaterials, indexToRemove)
        const queryRoute = `/marketing/email/${marketingMaterials[indexToRemove].id}`
        consoleDevLog(queryRoute)
        api.delete(queryRoute)
        removeMarketingMaterial(indexToRemove)
    }

    const filteredDesigns = marketingMaterials.filter(design => {
        return design.title.toLowerCase().includes(searchTerm.toLowerCase());
    });
    consoleDevLog(filteredDesigns)

    return (
        <Container>

            <Grid container spacing={3}>
                <Breadcrumb />

                <Grid item xs={12}>
                    <Typography variant="h4" className={classes.headerTitleLeft}>Smart Marketing</Typography>
                    {/*<hr className="horizontal-line" />*/}
                </Grid>

                {comingSoon && <ComingSoon />}

                {!comingSoon && <Grid item xs={12} style={{marginTop: "20px"}}>
                    <Typography variant="h4">Preferred Ad Types</Typography>
                </Grid>}

                {!comingSoon && <Grid item xs={12}>
                    <Grid container spacing={3}>
                        {categories.map((category, i) => (
                            <Grid item key={i} xs={12} sm={6} md={4} lg={3}>
                                <Card className={classes.card}>
                                    <CardActionArea onClick={() => handleClick(category.name)}>
                                        <CardMedia
                                            className={classes.media}
                                            image={category.img}
                                            title={category.name}
                                        />
                                    </CardActionArea>
                                    <Grid container alignItems="center" justifyContent="space-between">
                                        <Grid item>
                                            <Button
                                                className="create-button"
                                                variant="contained"
                                                color="primary"
                                                onClick={() => history.push(`/smart-marketing/${category.name}`)}
                                            >
                                                <p style={{ margin: "7px", color: "white" }}>Create</p>
                                            </Button>
                                        </Grid>
                                        <Grid item xs>
                                            <Typography variant="h6" align="left" style={{ paddingLeft: '16px' }}>
                                                {category.name}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>}

                {!comingSoon && <Grid item xs={12} style={{marginTop: "-40px", marginBottom: "-30px"}}>
                    <Typography variant="h4" align="left" className="header-title">
                        Recently Created Smart Designs
                    </Typography>
                </Grid>}

                {!comingSoon && <Grid item xs={12}>
                    <Box position="relative" className="report-search" mt={3}>
                        <TextField
                            variant="standard"
                            placeholder="Search by report name or client..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>
                </Grid>}

                {!comingSoon && <Grid item xs={12} style={{marginTop: "-17px"}}>
                    <Grid container spacing={3}>
                        {filteredDesigns.map((report, index) => (
                            <Grid item xs={12} md={4} key={report.title}>
                                <Card className="cma-card">
                                    <Grid container>
                                        <Grid item xs={5}>
                                            <CardMedia
                                                component="img"
                                                alt={report.title}
                                                height="140"
                                                image={report.img}
                                                title={report.title}
                                                className="cma-image"
                                            />
                                        </Grid>
                                        <Grid item xs={7} className="cma-content">
                                            <Typography variant="h5">{report.title}</Typography>
                                            <Typography variant="body2">
                                                Report Type: {report.type}
                                            </Typography>
                                            <Typography variant="body2">
                                                Client: {report.client}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container className="cma-actions">
                                        <Grid item xs={5}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                className="cma-edit-btn"
                                                sx={{ borderRadius: '50px' }}
                                                onClick={() => history.push(`/smart-marketing/E-mail/precon`)}
                                            >
                                                Edit
                                            </Button>
                                        </Grid>
                                        <Grid item xs={7}>
                                            <Button variant="contained" className="cma-export-btn" onClick={
                                                (event) => {
                                                    event.stopPropagation();
                                                    handleRemoveEmail(index);
                                                }
                                            }>
                                                Delete
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>}
            </Grid>
        </Container>
    );
}

export default SmartMarketing;